import qs, { type IParseOptions, type IStringifyOptions } from 'qs';

export const DEFAULT_ROUTE = '/overview';
export const INVITATION_ROUTE = '/invitation';

export const routes = [DEFAULT_ROUTE, INVITATION_ROUTE];

export const STRINGIFY_OPTIONS: IStringifyOptions = {
    // required to stringify arrays into comma separated strings
    arrayFormat: 'comma',
    // don't use array indices
    indices: false,
    // don't encode the entire string as it will be done individually for certain params
    encode: false,
    // required to remove empty params
    skipNulls: true,
};

export const PARSE_OPTIONS: IParseOptions = {
    // required to parse comma separated string into array
    comma: true,
};

export type RouteState = {
    partnerId: string | undefined;
    showCreateDialog: string | undefined;
    showServiceInfoDialog: string | undefined;
    serviceInfoChapter: string | undefined;
    restrictConnectionType: string | undefined;
};

export const parseRoute = (locationSearch: string): RouteState => {
    const decodedSearch = decodeURIComponent(locationSearch.replace('?', ''));
    const { partnerId, showCreateDialog, showServiceInfoDialog, serviceInfoChapter } = qs.parse(
        decodedSearch,
        PARSE_OPTIONS
    );

    return {
        partnerId,
        showCreateDialog,
        showServiceInfoDialog,
        serviceInfoChapter,
    } as RouteState;
};

export const makeRoute = (searchParams: RouteState): string => {
    const queryParams = qs.stringify(searchParams, STRINGIFY_OPTIONS);
    const searchFragment = queryParams && `?${queryParams}`;
    return encodeURI(searchFragment);
};
